export enum UserRoles {
  SUPER_USER = 1,
  SUBJECT_COORDINATOR,
  NURSING_STUDENT,
  TUTOR,
} // don't change the order of this enum

export enum UserRoleValues {
  "Super User" = 1,
  "Subject Coordinator",
  "Student",
  "Tutor",
} // don't change the order of this enum
interface UserRoleInfo {
  label: string;
  route: string;
}

export const UserRolesInfo: Record<UserRoles, UserRoleInfo> = {
  [UserRoles.SUPER_USER]: {
    label: "Super User",
    route: "/admin",
  },
  [UserRoles.SUBJECT_COORDINATOR]: {
    label: "Subject Coordinator",
    route: "/coordinator",
  },
  [UserRoles.NURSING_STUDENT]: {
    label: "Nursing Student",
    route: "/student",
  },
  [UserRoles.TUTOR]: {
    label: "Tutor",
    route: "/tutor",
  },
};

export enum AlertType {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

export enum Gender {
  MALE = "Male",
  FEMALE = "Female",
  OTHER = "Other",
}

export enum MRSA {
  POSITIVE = "Positive",
  NEGATIVE = "Negative",
}

export enum UserResponse {
  YES = "Yes",
  NO = "No",
}

export enum MedicineType {
  PRN = "PRN",
  REGULAR = "Regular",
  VARIABLE = "Variable Dose",
  ONE_TIME_MEDICINE = "Once Only"
}

export const OnceOnlyMedicine = "Once Only Medication"

export const MedicineTypeDropdown = [
  {
    value: MedicineType.PRN,
    name: "PRN Medicine",
  },
  {
    value: MedicineType.REGULAR,
    name: "Regular Medicine",
  },
  {
    value: MedicineType.VARIABLE,
    name: "Variable Dose Medicine",
  },
  {
    value:MedicineType.ONE_TIME_MEDICINE,
    name:OnceOnlyMedicine,
  }
];

export enum EComponentType {
  assignStudents = "AssignStudents",
}

export enum ManageRoleTabs {
  STUDENT_TUTOR = "Student and Tutor",
  STAFF = "Staff",
}

export enum ManageRoleValues {
  STUDENT_TUTOR = "Students and Tutors",
  STAFF = "Staff",
}

export enum ManageSelectValue {
  BULK = "bulk",
  INCREMENTAL = "incremental",
  STAFF = "staff",
}

export enum ManageRoleUploadCaption {
  BULK = "To assign roles and permission to multiple nursing students and tutors using the Bulk Upload method with a CSV Template, download the CSV Template below, enter the Student/Tutor Code, First Name, Last Name, Login ID, Email ID, Role Name and Cohort Name in the respective columns, save the file, and then upload it for import.",
  INCREMENTAL = "To assign roles and permission to multiple nursing students and tutors using Incremental Upload method with a CSV Template, download the CSV Template below, enter the Student/Tutor Code, First Name, Last Name, Login ID, Email ID, Role Name and Cohort Name in the respective columns, save the file, and then upload it for import.",
  STAFF = "To assign roles and permissions to staff members using the CSV template, download the CSV Template below, enter the Staff Code, First Name, Last Name, Login ID , Email ID and Role Name in the respective columns, save the file, and then upload it for import.",
}

export const RoleDropdownList = [
  {
    value: UserRoles.SUPER_USER,
    name: UserRoleValues[UserRoles.SUPER_USER],
  },
  {
    value: UserRoles.SUBJECT_COORDINATOR,
    name: UserRoleValues[UserRoles.SUBJECT_COORDINATOR],
  },
  {
    value: UserRoles.NURSING_STUDENT,
    name: UserRoleValues[UserRoles.NURSING_STUDENT],
  },
  {
    value: UserRoles.TUTOR,
    name: UserRoleValues[UserRoles.TUTOR],
  },
];

export const UserStatus = [
  {
    value: 1,
    name: "Active",
  },
  {
    value: 0,
    name: "Inactive",
  },
];

export enum EGridStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  PENDING = "PENDING",
  IN_PROGRESS = "IN PROGRESS",
  COMPLETED = "COMPLETED",
}

export enum DynamicPages {
  SHIFT_PLANNER = 1,
  ADHOC_TOOL,
}

export enum SPActionType {
  CANCEL = "cancel",
  EDIT = "edit",
  DELETE = "delete",
  SUBMIT = "submit",
}
export enum ICONS {
  WARNING = "warning",
  DELETE = "delete",
}
